export const RECAPTCHA_FG2 = 'ySIIx5X+T1ha'; // usando um nome diferente
